import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { MenuIcon } from 'components/icons';
import OtherHousesIcon from '@mui/icons-material/OtherHouses';
import { Tooltip } from '@mui/material';
import { CANparkTabs } from 'pages/CANpark/CANpark';
import OverstayNotificationBell from './OverstayNotificationBell';
import OnboardingHelpButton from 'components/onboarding/OnboardingHelpButton';

interface CANparkBarProps {
	activeTab: CANparkTabs;
	onMenuClick: () => void;
	handleTabChange: (tab: CANparkTabs) => void;
}

export default function CANparkBar({
	activeTab,
	onMenuClick,
	handleTabChange,
}: CANparkBarProps) {
	return (
		<Box>
			<AppBar position="static" color="default">
				<Toolbar
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: { xs: 'space-between', md: 'center' },
						alignItems: 'center',
					}}
				>
					<Box
						sx={{
							display: { xs: 'flex', md: 'flex' },
							position: 'absolute',
							top: 5,
							left: 10,
						}}
					>
						<IconButton
							size="large"
							aria-label="show menu"
							onClick={onMenuClick}
							color="inherit"
						>
							<MenuIcon />
						</IconButton>
					</Box>

					<Box
						sx={{
							display: { xs: 'flex', md: 'flex' },
							alignItems: 'center',
							position: 'absolute',
							top: 5,
							right: 10,
						}}
					>
						<OnboardingHelpButton />
						<OverstayNotificationBell />
					</Box>

					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							overflowX: 'auto',
							justifyContent: 'space-between',
							width: '100%',
						}}
					>
						<Box
							sx={{
								display: 'flex',
								gap: 1,
								width: '100%',
								justifyContent: 'center',
							}}
						>
							<Tooltip title="Home">
								<IconButton
									size="large"
									color={
										activeTab === CANparkTabs.Home
											? 'primary'
											: 'inherit'
									}
									onClick={() =>
										handleTabChange(CANparkTabs.Home)
									}
								>
									<OtherHousesIcon />
								</IconButton>
							</Tooltip>
						</Box>
					</Box>
				</Toolbar>
			</AppBar>
		</Box>
	);
}
